import React from 'react';

import { addStory } from 'lib/story-books';

import { Text } from '.';

addStory('text', () => <Text>Text</Text>);
